import { ViewContainerRef } from '@angular/core';
import { Component, TemplateRef, Input, ChangeDetectorRef, ViewChild, AfterViewInit, NgIterable } from '@angular/core';
import { DynamicListDirective } from './dynamic-list.directive';

export type QuickListSelectEvent = { elm: HTMLOptionElement, value: Object | string | undefined | null };

@Component({
    selector: 'skl-list-content',
    template: `
        <ng-container #viewContainer></ng-container>
    `
})
export class QuickListContentComponent<T, C> implements AfterViewInit {
    @ViewChild('viewContainer', { read: ViewContainerRef }) private viewContainer!: ViewContainerRef;

    @Input() public dynamicList!: DynamicListDirective<T, NgIterable<T>>;

    @Input() public listTemplate!: TemplateRef<C>;

    @Input() public context!: C;

    public constructor(
        private changeDetector: ChangeDetectorRef
    ) {}

    public ngAfterViewInit(): void {
        this.viewContainer.createEmbeddedView(this.listTemplate, this.context);
        this.changeDetector.detectChanges();
    }
}
